<div class="search-container">
  <div class="search-input">
    <input id="searchInput" class="large-input assessment-text-regular-16 searchinput" placeholder="Search by name" type="text">
    <svg id="Layer_2" class="search-icon" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="16.869" height="16.869" viewBox="0 0 16.869 16.869">
      <path id="search" d="M19.592,18.262l-3.185-3.176a7.42,7.42,0,0,0,1.583-4.591,7.495,7.495,0,1,0-7.495,7.495,7.42,7.42,0,0,0,4.591-1.583l3.176,3.185a.941.941,0,1,0,1.33-1.33ZM4.874,10.495a5.621,5.621,0,1,1,5.621,5.621,5.621,5.621,0,0,1-5.621-5.621Z" transform="translate(-3 -3)" fill="#5f6368"/>
    </svg>
  </div>
</div>
